import moment from 'moment';

export default {
	methods: {
		dateFormat(date, format = 'DD-MM-YYYY') {
			return this.moment(date).format(format);
		},

		moment(date) {
			return moment(date);
		}
	}
}